import { Form, Head } from "@inertiajs/react"

import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Spinner } from "@/components/ui/spinner"
import AuthLayout from "@/layouts/auth-layout"
import { claimPath } from "@/routes"

interface Props {
  org_slug: string
  suggested_name: string
  suggested_email_subdomain: string
}

export default function ClaimOrg({
  org_slug,
  suggested_name,
  suggested_email_subdomain,
}: Props) {
  return (
    <AuthLayout
      title="Claim your org"
      description="Pick a name + a vanity email subdomain. Your 14-day trial starts now."
    >
      <Head title="Claim your org" />
      <Form
        method="post"
        action={claimPath(org_slug)}
        className="flex flex-col gap-6"
      >
        {({ processing, errors }) => (
          <>
            <div className="grid gap-2">
              <Label htmlFor="name">Organization name</Label>
              <Input
                id="name"
                name="name"
                type="text"
                required
                defaultValue={suggested_name}
                placeholder="Acme Bulk Terminal"
                autoFocus
              />
              <InputError messages={errors.name} />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="email_subdomain">Email subdomain</Label>
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground text-sm">tickets@</span>
                <Input
                  id="email_subdomain"
                  name="email_subdomain"
                  type="text"
                  required
                  pattern="[a-z0-9-]{2,32}"
                  minLength={2}
                  maxLength={32}
                  defaultValue={suggested_email_subdomain}
                  placeholder="acme-bulk"
                />
                <span className="text-muted-foreground text-sm">
                  .rebulk.com
                </span>
              </div>
              <p className="text-muted-foreground text-xs">
                Forward scale tickets here to ingest into your tenant.
              </p>
              <InputError messages={errors.email_subdomain} />
            </div>

            <Button type="submit" disabled={processing}>
              {processing && <Spinner />}
              Claim {org_slug}
            </Button>
          </>
        )}
      </Form>
    </AuthLayout>
  )
}
